import React, {Component} from 'react';
import './App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField'
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import SearchIcon from "@material-ui/icons/Search"
import Button from "@material-ui/core/Button";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ReactGA from "react-ga";
import {connect} from 'react-redux';
import {givePrivileges} from './actions/privilegeActions'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import _ from 'lodash';
import {red} from '@material-ui/core/colors';
import {withSnackbar} from 'notistack';
import {bffUrl} from './config.js'


const styles = theme => ({
    container: {
        position: 'relative',
    },
});


class FindProgrammingContainer extends Component {

    constructor(props) {

        super(props);

        this.selectedRows = [];

        this.state = {
            active: true,
            contentType: 0,
            contentId: '',
            errorMessages: {},
            findData: null,
            deactiveAll: false,
            selectedData: [],
            actualEntityData: {},
            dataToSend: [],
            hasOttToolRight: false,
            rights: [],
            isActive: true, // for anable/disable the checkbox,
            regionRights: [],
            dialogBoxOpen: false,
            snackBarOpen: false,
            singleCardData: [],
            nonSingleCardData: []
        };


        this.columns = [
            {
                name: "Card Name",
                options: {
                    filter: false,
                }
            },
            {
                name: "Region"
            },
            {
                name: "Subregion"
            },
            {
                name: "Product"
            },
            {
                name: "Page"
            },
            {
                name: "ContentId"
            },
            {
                name: 'Display Name',
                options: {
                    display: 'false'
                }
            },
            {
                name: 'Updated By',
            },
            {
                name: 'Create Time',
                options: {
                    display: 'false'
                }
            },
            {
                name: 'Update Time',
                options: {
                    display: 'false'
                }
            }
        ];

    }

    //copy entire array
    copySelectedData = (data) => {
        console.log("inside copy functions");
        let cloned = Object.assign({}, data);

        this.setState({
            selectedData: cloned
        })

    };


    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };
    handleChangeRadio = event => {
        this.setState({contentType: event.target.value});
    };

    handleChangeSwitch = name => event => {
        this.setState({[name]: event.target.checked});
    };

    // for select onChange Event . Updating the state by options
    handleChangeOption = event => {
        this.setState({
            active: event.target.value
        })
    };

    deactiveAllHandle = (event) => {

        this.setState({
            deactiveAll: event.target.checked
        }, () => {
            console.log(this.state.deactiveAll)
        })

    };

    rightsValidationAndRetrieveRegionList = () => {
        let self = this;

        // for temporary storing rights
        let regionRightsTemp = [];

        if(this.props && this.props.privileges && this.props.privileges.length>0){
            this.props.privileges.forEach(privilege => {
                // check the /ott/list rights
                if (privilege.url && privilege.url === '/ott/list') {
                    self.setState({
                        hasOttToolRight: true
                    })
                }

                // if url ends with OTT
                // tokenize and get the id of the region
                if (privilege.url.endsWith("OTT")) {
                    let url = privilege.url;
                    let res = url.split("_");
                    if (privilege.url !== "Viu_OTT") {
                        regionRightsTemp.push(res[res.length - 2]);
                    }
                }
            });

            // store the regions in state
            self.setState({
                regionRights: regionRightsTemp
            }, () => {
                console.log("in rights get");
            })
        }




    };

    searchProgramming() {

        this.props.getPrivileges();

        this.rightsValidationAndRetrieveRegionList();


        let self = this;
        let contentId = this.state.contentId;
        let contentType = this.state.contentType;
        let activeStatus = this.state.active;
        // let activeStateNumber = this.state.activeStateNumber;
        let serverUrl = `${bffUrl}/video/findContent`;
        // serverUrl = 'http://localhost:1337/video/findContent';

        // change base url by the activeStatus 
        let baseUrl = `${serverUrl}?contentId=${contentId}&contentType=${contentType}`;

        // changing the baseUrl by option 
        if (activeStatus !== null) {
            baseUrl = `${serverUrl}?contentId=${contentId}&contentType=${contentType}&active=${activeStatus}`
        }

        let contentTypeString = "find-programming-";
        if (this.state.contentType == 1) {
            contentTypeString = contentTypeString + 'playlist';
        } else {
            contentTypeString = contentTypeString + 'clip';
        }

        let activeTypeString = "FIND-";

        if (this.state.active === true) {
            activeTypeString = activeTypeString + 'ACTIVE';
        } else if (this.state.active === null) {
            activeTypeString = activeTypeString + 'ALL';
        } else {
            activeTypeString = activeTypeString + "INACTIVE"
        }

        ReactGA.ga('send', 'event',
            contentTypeString,
            activeTypeString,
            this.state.contentId,
            1);


        const findInstance = axios.create({
            baseURL: baseUrl,
            timeout: 120000,
            headers: {'ACCEPT': 'application/vnd.vuclip.cms.v2+json;charset=UTF-8'}
        });


        self.setState({
            errorMessages: {}
        });

        findInstance.get()
            .then(function (response) {
                self.setState({
                    findData: null
                }, () => {

                });

                if (response.data) {
                    if (response.data.responseType === "SUCCESS") {
                        if (response.data.entity) {

                            console.log("Change State");

                            let flatResponseData = [];
                            let searchResponse = response.data.entity;
                            if (searchResponse && searchResponse.length > 0) {
                                let responseData = searchResponse;
                                let responseElement = [];
                                responseData.forEach(function (data) {
                                    responseElement = [];
                                    if (data) {
                                        if (data.name) {
                                            responseElement.push(data.name);
                                        } else {
                                            responseElement.push('');
                                        }
                                        if (data.region) {
                                            responseElement.push(data.region.name);
                                        } else {
                                            responseElement.push('');
                                        }
                                        if (data.subRegion) {
                                            responseElement.push(data.subRegion.name);
                                        } else {
                                            responseElement.push('');
                                        }
                                        if (data.product) {
                                            responseElement.push(data.product.name);
                                        } else {
                                            responseElement.push('');
                                        }
                                        if (data.page) {
                                            responseElement.push(data.page.name);
                                        } else {
                                            responseElement.push('');
                                        }
                                        if (data.content) {
                                            if (data.content[0].contentId) {
                                                responseElement.push(data.content[0].contentId);
                                            } else {
                                                responseElement.push('');
                                            }
                                            if (data.content[0].displayName) {
                                                responseElement.push(data.content[0].displayName);
                                            } else {
                                                responseElement.push('');
                                            }
                                            if (data.content[0].lastUpdatedBy) {
                                                responseElement.push(data.content[0].lastUpdatedBy);
                                            } else {
                                                responseElement.push('');
                                            }
                                            if (data.content[0].createTime) {
                                                responseElement.push(data.content[0].createTime);
                                            } else {
                                                responseElement.push('');
                                            }
                                            if (data.content[0].lastUpdateTime) {
                                                responseElement.push(data.content[0].lastUpdateTime);
                                            } else {
                                                responseElement.push('');
                                            }
                                        }
                                        flatResponseData.push(responseElement)
                                    }
                                })
                            }

                            if (flatResponseData && flatResponseData.length > 0) {
                                self.setState({findData: flatResponseData});
                            } else {
                                self.setState({findData: null});
                            }


                            // storing data as it came
                            self.setState({
                                actualEntityData: response.data.entity
                            });
                            console.log(self.state.actualEntityData);

                        } else {
                            self.props.enqueueSnackbar("Data Doen't Exist", {
                                variant: 'warning', anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                },
                                autoHideDuration: 3000
                            });

                            if (response.data.genericMessages && response.data.genericMessages.ERROR && response.data.genericMessages.ERROR.length > 0) {
                                self.setState({
                                    findData: null, loadingVideo: false, errorMessages: response.data.genericMessages
                                });
                            }
                        }
                    } else {
                        self.props.enqueueSnackbar("Failure While Fetching Data", {
                            variant: 'warning', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            },
                            autoHideDuration: 3000
                        });
                    }
                } else {
                    self.props.enqueueSnackbar("Data Doen't Exist", {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000
                    });
                    self.setState({
                        findData: null, loadingVideo: false
                    });
                }

            }, function () {
                self.setState({findData: null, loadingVideo: false})
            })
            .catch(function (error) {
                self.props.enqueueSnackbar("Failure While Fetching Data", {
                    variant: 'warning', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    autoHideDuration: 3000
                });
                self.setState({findData: null, loadingVideo: false})
            });

    }

    googleAnalyticsHandler = (actionName) => {

        if (this.state.dataToSend) {
            this.state.dataToSend.map(data => {

                var category = "find-programming-playlist";
                var action = actionName;
                var cardName = data.name;
                var regionName = data.region.name;
                var subRegionName = data.subRegion.name;
                var productName = data.product.name;
                var label = cardName + "-" + regionName + "-" + subRegionName + "-" + productName;

                ReactGA.ga('send', 'event',
                    category,
                    action,
                    label,
                    1);
            })
        }

    };

    DataInactivateHandler = () => {

        let self = this;
        let errorFlag = false;

        // console.log(self.state.dataToSend)
        self.state.dataToSend.map(data => {
            if (data.content[0].isActive) {
                data.content[0].isActive = false
            }
        });

        var actionName = "DEACTIVATE-BUTTON-CLICK";
        self.googleAnalyticsHandler(actionName);

        //var url = "http://localhost:1337/findprogramming/getAffectedCards";
        var url = bffUrl + `/findprogramming/getAffectedCards`;

        const getAffectedCards = axios.create({
            baseURL: url,
            timeout: 120000
        });

        getAffectedCards.post(url, self.state.dataToSend)
            .then(function (res) {
                console.log("Success");
                // get nonsingle card data
                // NON-SINGLE  = After Inativate Content from Card still Card has some content inside it
                if (res.data.entity["NON-SINGLE"]) {
                    self.setState({
                        nonSingleCardData: res.data.entity["NON-SINGLE"]
                    }, () => {
                        console.log("non single card")
                    })
                }

                // get single card data
                // SINGLE  = After Inativate Content from Card . Card would be empty
                if (res.data.entity.SINGLE) {
                    self.setState({
                        singleCardData: res.data.entity.SINGLE
                    }, () => {
                        console.log("non single card")
                    })
                }
            })
            .catch(function (error) {
                console.log("Fail");
                console.log(error);
                errorFlag = true;
            });

        if (errorFlag) {

            self.props.enqueueSnackbar('Failed to Load Data', {
                variant: 'warning', anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                },
                autoHideDuration: 3000
            });

        } else {
            self.setState({
                dialogBoxOpen: true
            })
        }

    };

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.selectedData != nextState.selectedData) {
            return true
        }
        return true
    }

    dialogBoxCloseHandler = () => {

        var actionName = "DEACTIVATE-REJECT";
        this.googleAnalyticsHandler(actionName);
        this.setState({
            dialogBoxOpen: false
        })
    };

    snackBarCloseHandler = () => {
        this.setState({
            snackBarOpen: false
        })
    };

    acceptDeactivateContentHandler = () => {

        let self = this;

        var actionName = "DEACTIVATE-CONFIRM";
        self.googleAnalyticsHandler(actionName);

        var userName = sessionStorage.getItem("userName");
        console.log(userName);

        self.setState({
            dialogBoxOpen: false
        });

        //var url = "http://localhost:1337/findprogramming/updateAffectedStatus";
        var url = bffUrl + `/findprogramming/updateAffectedStatus`;

        const updateAffectedStatus = axios.create({
            baseURL: url,
            timeout: 120000
        });

        updateAffectedStatus.put(`${url}?username=${userName}`, self.state.dataToSend)
            .then(res => {
                console.log("Success");
                if (res.status === 200) {
                    // for success msg
                    actionName = "DEACTIVATE-SUCCESS";
                    self.googleAnalyticsHandler(actionName);

                    self.props.enqueueSnackbar('Inactivation of Contents Successfully Done!', {
                        variant: 'success', anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000
                    });
                }

                if (res.status === 400) {
                    // for error msg

                    actionName = "DEACTIVATE-FAILURE";
                    self.googleAnalyticsHandler(actionName);

                    self.props.enqueueSnackbar('Inactivation of Contents Failed!', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        },
                        autoHideDuration: 3000
                    });
                }
            }).catch(err => {
            console.log("error");
            console.log(err);
            var actionName = "DEACTIVATE-FAILURE";
            self.googleAnalyticsHandler(actionName);

            self.props.enqueueSnackbar('Inactivation of Contents Failed!', {
                variant: 'warning', anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                },
                autoHideDuration: 3000
            });
        }).then(() => {
            console.log("End");
            // make all state to its initial One
            self.setState({
                active: true,
                contentType: 0,
                contentId: '',
                errorMessages: {},
                findData: null,
                deactiveAll: false,
                selectedData: [],
                actualEntityData: {},
                dataToSend: [],
                hasOttToolRight: false,
                rights: [],
                regionRights: []
            });

            //refresh the page
            setTimeout(() => {
                window.location.reload();
            }, 2000)

        })

    };


    render() {
        const {classes, theme} = this.props;
        const flex = {flexGrow: 1};

        const buttonIconStyle = {
            marginRight: theme.spacing(1),
        };

        const containerStyle = {
            minHeight: '650px'
        };

        const formControl = {
            margin: theme.spacing(1),
            minWidth: 200,
        };

        const selectEmpty = {
            marginTop: theme.spacing(2),
        };

        const contentIdInputStyle = {};

        const options = {
            isRowSelectable: (dataIndex) => {

                // check rights for ott
                if ((this.state.hasOttToolRight == false)) {
                    return false
                }

                // check for data exist or not
                if (this.state.actualEntityData[dataIndex]) {
                    // check for active and inactive content
                    // if card in inactive or the content is inactive
                    if (this.state.actualEntityData[dataIndex].content[0].isActive === false || this.state.actualEntityData[dataIndex].active === false) {
                        return false;
                    }

                    // check for region rights 
                    var regionId = this.state.actualEntityData[dataIndex].region.id.toString();
                    console.log("regionId" + regionId);
                    if (this.state.regionRights.indexOf(regionId) < 0) {
                        return false
                    }
                }

                return true;
            },
            filterType: 'multiselect',
            pagination: true,
            selectedRows: {
                text: '',
                delete: ''
            },
            selectableRows: true,
            print: false,
            onRowsDelete: (data) => {
            },
            // delete : '',
            rowsSelected: this.selectedRows,
            customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
                <React.Fragment/>
            ),

            responsive: 'scrollable',

            onRowsSelect: (cur, all) => { // this method is for fetching all selected rows


                if (cur.length > 0) {
                    let flag = true;
                    // Google Analytics

                    if (this.state.dataToSend) {
                        this.state.dataToSend.forEach(data => {
                            if (data.cardId === this.state.actualEntityData[cur[0].index].cardId) {
                                flag = false;
                            }
                        })
                    }

                    if (flag) {
                        // console.log("event fire");
                        var category = "find-programming-playlist";
                        var action = "DEACTIVATE-SELECT";
                        var cardName = this.state.actualEntityData[cur[0].index].name;
                        var regionName = this.state.actualEntityData[cur[0].index].region.name;
                        var subRegionName = this.state.actualEntityData[cur[0].index].subRegion.name;
                        var productName = this.state.actualEntityData[cur[0].index].product.name;
                        var label = cardName + "-" + regionName + "-" + subRegionName + "-" + productName;

                        ReactGA.ga('send', 'event',
                            category,
                            action,
                            label,
                            1);
                    }
                }


                this.setState({selectedData: all});
                console.log("inside onRowsSelect");
                this.copySelectedData(all);

                this.selectedRows = [...all];

                // storing temp data to send
                var dataToSendCopy = [];

                if (all.length > 0) {
                    all.forEach(index => {

                        var currentData = _.cloneDeep(this.state.actualEntityData[index.index]);

                        dataToSendCopy.push(currentData);

                    })
                }

                console.log("after loop");
                // store data to send in state
                this.setState({
                    dataToSend: dataToSendCopy
                })

            }

        };

        return (
            <React.Fragment>

                {
                    (this.state.singleCardData && Object.keys(this.state.singleCardData).length > 0) ||
                    (this.state.nonSingleCardData && Object.keys(this.state.nonSingleCardData).length > 0) ?
                        <Dialog
                            fullWidth={true}
                            // fullScreen = { true }
                            open={this.state.dialogBoxOpen}
                            onClose={this.dialogBoxCloseHandler}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >

                            {
                                this.state.singleCardData && Object.keys(this.state.singleCardData).length > 0 ?
                                    <React.Fragment>
                                        <DialogTitle id="alert-dialog-title" style={{paddingBottom: "0px"}}><span
                                            style={{color: "red"}}>Following Cards would be Removed from Programming</span>
                                            <Typography variant="caption" gutterBottom style={{color: "grey"}}>
                                                Because these cards would be empty
                                            </Typography>
                                            <Typography variant="overline" gutterBottom>
                                                <b> Card Name </b> [ Page Name - Region - Subregion - Platform ]
                                            </Typography>
                                        </DialogTitle>

                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                {
                                                    this.state.singleCardData && Object.keys(this.state.singleCardData).length > 0
                                                        ? <div>
                                                            {
                                                                this.state.singleCardData.map(data => (<p>
                                                                    <b> {data.name} </b> [ {data.page.name} - {data.region.name} - {data.subRegion.name} - {data.product.name} ]
                                                                </p>))
                                                            }
                                                        </div>
                                                        : null
                                                }
                                            </DialogContentText>
                                        </DialogContent>
                                    </React.Fragment>
                                    : null

                            }

                            {
                                this.state.nonSingleCardData && Object.keys(this.state.nonSingleCardData).length > 0 ?
                                    <React.Fragment>
                                        <DialogTitle id="alert-dialog-title" style={{paddingBottom: "0px"}}><span
                                            style={{color: "red"}}>Following Playlists will be Inactivated</span>
                                            <Typography variant="overline" gutterBottom>
                                                <b> Card Name </b> [ Page Name - Region - Subregion - Platform ]
                                            </Typography>
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description">
                                                {
                                                    this.state.nonSingleCardData && Object.keys(this.state.nonSingleCardData).length > 0
                                                        ? <div>
                                                            {
                                                                this.state.nonSingleCardData.map(data => (<p>
                                                                    <b> {data.name} </b> [ {data.page.name} - {data.region.name} - {data.subRegion.name} - {data.product.name} ]
                                                                </p>))
                                                            }
                                                        </div>
                                                        : null
                                                }
                                            </DialogContentText>
                                        </DialogContent>
                                    </React.Fragment>
                                    : null
                            }

                            <DialogActions>
                                <Button variant="contained" color="secondary" onClick={this.dialogBoxCloseHandler}
                                        style={{color: "white"}}>
                                    REJECT
                                </Button>
                                <Button variant="contained" color="primary"
                                        onClick={this.acceptDeactivateContentHandler} autoFocus>
                                    ACCEPT
                                </Button>
                            </DialogActions>
                        </Dialog>
                        : null
                }

                <Paper style={containerStyle}>
                    <br/>

                    <Grid container spacing={0}
                          direction="row"
                          justify="space-around"
                          alignItems="center">
                        <Grid item sm={2}/>
                        <Grid item sm={2}>
                            <TextField style={contentIdInputStyle}
                                       variant="outlined"
                                       label="Enter Content ID"
                                       value={this.state.contentId}
                                       onChange={this.handleChange('contentId')}
                            />
                        </Grid>
                        <Grid item sm={2}>
                            <FormLabel>Clip</FormLabel>
                            <Radio
                                checked={this.state.contentType == 0}
                                onChange={this.handleChangeRadio}
                                value={0}
                                name="contentType"
                                aria-label="clip"
                            />
                            <FormLabel>Playlist</FormLabel>
                            <Radio
                                checked={this.state.contentType == 1}
                                onChange={this.handleChangeRadio}
                                value={1}
                                name="contentType"
                                aria-label="playlist"
                            />
                        </Grid>
                        <Grid item sm={1}>
                            <FormControl style={formControl}>
                                <InputLabel shrink>
                                    Status
                                </InputLabel>

                                <Select
                                    value={this.state.active}
                                    displayEmpty
                                    name="state"
                                    style={selectEmpty}
                                    onChange={this.handleChangeOption}
                                >
                                    <MenuItem value={true}>
                                        Active
                                    </MenuItem>

                                    <MenuItem value={false}>Inactive</MenuItem>
                                    <MenuItem value={null}>Both</MenuItem>
                                </Select>
                            </FormControl>

                        </Grid>

                        <Grid item sm={1}>
                            <Button variant="contained" color="primary" onClick={this.searchProgramming.bind(this)}>
                                <SearchIcon style={buttonIconStyle}/>
                                Find
                            </Button>
                        </Grid>

                        <Grid item sm={1}/>
                        <Grid item sm={1}>


                        </Grid>
                        <Grid item sm={1}/>
                    </Grid>

                    {this.state.findData &&
                    <Grid container spacing={0}
                          direction="row"
                          justify="space-around"
                          alignItems="center">

                        <Grid item sm={12}>

                            <MUIDataTable
                                title={"Search Results"}
                                data={this.state.findData}
                                columns={this.columns}
                                options={options}
                            />
                        </Grid>
                    </Grid>}

                    {this.state.selectedData && Object.keys(this.state.selectedData).length > 0
                        ?
                        <Button variant="contained" color="secondary" style={classes.button}
                                onClick={this.DataInactivateHandler} style={{
                            marginLeft: "50%",
                            textAlign: 'center',
                            color: 'white',
                            marginTop: '15px',
                            marginBottom: '15px'
                        }}>
                            Inactivate
                        </Button>
                        : null
                    }

                    {this.state.errorMessages && this.state.errorMessages.ERROR && this.state.errorMessages.ERROR.length > 0 &&
                    <Grid container spacing={0}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            {this.state.errorMessages.ERROR.map(function (errorMessage, index) {
                                return (<Typography variant='title' key={index} color='secondary'>
                                    Error : {errorMessage.message}
                                </Typography>)
                            })}
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>}
                </Paper>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        privileges: state.privilege.privileges
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPrivileges: () => dispatch(givePrivileges())
    }
};

FindProgrammingContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const FindProgramContainer = withSnackbar(FindProgrammingContainer);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, {withTheme: true})(FindProgramContainer));
